import { Dica } from "@/componentes/Dica";

/*
 * O estado de uma seção que a fundação reservou e ainda não construiu.
 *
 * O doc 06a §6 exige que o vazio não finja que quebrou, e nunca diga "Nenhum
 * dado encontrado". Uma linha curta diz o estado; o que vai existir — e por que
 * ainda não existe — mora na dica, para não virar parágrafo a cada abertura.
 */
export function EmBreve({ titulo, texto, dica }: {
  titulo: string;
  texto: string;
  dica?: string;
}) {
  return (
    <section className="flex flex-col gap-3">
      <h1 className="text-titulo font-semibold">{titulo}</h1>
      <p className="flex items-center gap-1 text-texto-2">
        {texto}
        {dica !== undefined && <Dica texto={dica} />}
      </p>
    </section>
  );
}
